import { convertEpochToDate } from '../../utils/utils'
import type { EliteReferralReward } from '../../types/misc.types'

export function hasEliteReferralReward(referralReward?: EliteReferralReward | null): boolean {
  if (!referralReward) return false
  return (
    typeof referralReward.planExtensionMonths === 'number' ||
    typeof referralReward.rewardExpiryTime === 'number'
  )
}

export function getEliteReferralRewardCopy(referralReward: EliteReferralReward): {
  title: string
  subtitle?: string
} {
  const planExtensionMonths = referralReward.planExtensionMonths ?? 1
  const rewardExpiryTime = referralReward.rewardExpiryTime
  let validTillLabel: string | undefined
  if (typeof rewardExpiryTime === 'number') {
    const expiryTimestampMs = rewardExpiryTime < 1e12 ? rewardExpiryTime * 1000 : rewardExpiryTime
    validTillLabel = convertEpochToDate(expiryTimestampMs, '%_d %B')
  }
  const monthLabel = planExtensionMonths === 1 ? '1 month' : `${planExtensionMonths} months`
  return {
    title: `${monthLabel} extra referral bonus applied`,
    subtitle: validTillLabel ? `Invite valid till ${validTillLabel}` : undefined
  }
}

export function EliteReferralRewardBanner({ referralReward }: { referralReward: EliteReferralReward }) {
  const rewardCopy = getEliteReferralRewardCopy(referralReward)

  return (
    <div className='flex items-center gap-2 bg-[#FFF5EB] px-4 py-3 text-left'>
      <EliteReferralGiftIcon />
      <div className='min-w-0'>
        <p className='text-[13px] font-medium leading-[1.3] text-[#BB4F22]'>
          {rewardCopy.title}
        </p>
        {rewardCopy.subtitle ? (
          <p className='mt-0.5 text-[12px] leading-[1.3] text-[#C4896A]'>
            {rewardCopy.subtitle}
          </p>
        ) : null}
      </div>
    </div>
  )
}

export function EliteReferralGiftIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path d="M14.9911 4.80469H3.01055C2.34889 4.80469 1.8125 5.34108 1.8125 6.00274V8.39884C1.8125 9.0605 2.34889 9.5969 3.01055 9.5969H14.9911C15.6528 9.5969 16.1891 9.0605 16.1891 8.39884V6.00274C16.1891 5.34108 15.6528 4.80469 14.9911 4.80469Z" stroke="#CC5C2D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.9883 9.60156V14.9928C14.9883 15.3105 14.8621 15.6153 14.6374 15.8399C14.4128 16.0646 14.108 16.1908 13.7903 16.1908H4.20586C3.88812 16.1908 3.58339 16.0646 3.35871 15.8399C3.13404 15.6153 3.00781 15.3105 3.00781 14.9928V9.60156" stroke="#CC5C2D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9 4.80469V16.1862" stroke="#CC5C2D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12.5946 1.8125L9.00041 4.80763L5.40625 1.8125" stroke="#CC5C2D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
